import axios, { AxiosResponse } from 'axios';

import { EStavUzivatele } from 'services/spravaUzivatelu/uzivatele';

export interface IPrehled {
    cval: string;
    eico: string;
    elei: string;
    ename: string;
    pdcp: string;
    regdt: string;
    tval: string;
}
export interface ISezIsinu {
    vydaneisiny: IPrehled[];
}

const EmitentIsins = (ico: string) => {
    return axios({
        method: 'GET',
        // url: `VydaneISINy?ico=${ico}`
        url: window.location.origin + `/isbpublicjson/api/VydaneISINy?ico=${ico}`
    }).then((resp: AxiosResponse<ISezIsinu>) => resp.data);
};

export interface IZmenaUctuData {
    nazev: string;
    adresa: string;
    stav: EStavUzivatele;
}

export const zmenitUcetEmitentApi = (id: number, data: IZmenaUctuData) => {
    return axios({
        method: 'POST',
        url: `/Portal/NastavitUcet/${id}/Zmena`,
        data: data
    }).then((resp: AxiosResponse<ISezIsinu>) => resp.data);
};

export default EmitentIsins;
